import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2"},[_c(VDataTable,{staticClass:"results-table",attrs:{"headers":_vm.productsTableHeaders,"items":_vm.list,"items-per-page":-1,"hide-default-footer":"","fixed-header":""},scopedSlots:_vm._u([{key:"item.netValue",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatValue(item.netValue, 'price'))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }